import { render, staticRenderFns } from "./barGroupManage.vue?vue&type=template&id=f83d2bc4&scoped=true&"
import script from "./barGroupManage.vue?vue&type=script&lang=js&"
export * from "./barGroupManage.vue?vue&type=script&lang=js&"
import style0 from "./barGroupManage.vue?vue&type=style&index=0&id=f83d2bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83d2bc4",
  null
  
)

component.options.__file = "barGroupManage.vue"
export default component.exports